<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="bg-authBackground h-full flex items-center justify-center"
        style="width: 45vw"
        to="/"
        aria-label="Visit homepage"
        ><div class="text-center p-12">
          <SpreadLogo :height="28" class="ml-2 p-12" start="#FFF" />
          <p>
            SPREAD is a new platform that connects music fans with their favorite artists around the world. With SPREAD,
            fans can experience live performances from the comfort of their own homes and on their own time. The
            platform offers 24-hour access to live shows after ticket purchase, making it easy for fans to enjoy live
            music on their own schedule. SPREAD also provides a unique opportunity for artists to reach a global
            audience and build a more intimate connection with their fans.  
          </p>
          <p class="mt-2">
            To get started on SPREAD, simply create an account, purchase a ticket to a live show, and then listen to the
            audio stream within 24 hours of the concert's start time.
          </p>
        </div>
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <SpreadLogo class="mb-2" start="#0E41C9" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { useBreakpoint, useColors } from 'vuestic-ui'
import SpreadLogo from '../components/SpreadLogo.vue'
import { useLocalStorage } from '@vueuse/core'

const { applyPreset, currentPresetName } = useColors()
const themePreset = useLocalStorage('theme-preset', 'dark')

const breakpoint = useBreakpoint()

onMounted(() => {
  applyPreset(themePreset.value)
})
</script>
